import Vue from 'vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
Vue.mixin({
  data() {
    return {
      notifeDefaults: {
        normal: {
          title: 'انجام شد',
          icon: 'BellIcon',
          variant: 'primary',
        },
        success: {
          title: 'عملیات با موفقیت انجام شد',
          icon: 'CheckIcon',
          variant: 'success',
        },
        error: {
          title: 'عملیات با خطا مواجه شد',
          icon: 'BellIcon',
          variant: 'danger',
        },
        warning: {
          title: 'عملیات با خطا مواجه شد ',
          icon: 'BellIcon',
          variant: 'warning',
        },
      },
    };
  },
  methods: {
    $notif({ type = 'normal', title = null, text = null, icon = null, variant = 'primary' }) {
      this.$toast({
        component: ToastificationContent,
        props: {
          text: text,
          title: title || this.notifeDefaults[type].title,
          icon: icon || this.notifeDefaults[type].icon,
          variant: this.notifeDefaults[type].variant || variant,
        },
      });
    },
  },
});
